module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_9.4217fef5.pdf";